import { render, staticRenderFns } from "./jkyUserSelect.vue?vue&type=template&id=0483dbbb&scoped=true"
import script from "./jkyUserSelect.vue?vue&type=script&lang=js"
export * from "./jkyUserSelect.vue?vue&type=script&lang=js"
import style0 from "./jkyUserSelect.vue?vue&type=style&index=0&id=0483dbbb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0483dbbb",
  null
  
)

export default component.exports